import { ApiResponse } from "../CustomFetch";
import { api } from "./BaseApi";
import { ExpertAvailabilityRequestModel } from "../../model/ExpertAvailabilityRequestModel";
import { ExpertAvailabilityViewModel } from "../../model/ExpertAvailabilityViewModel";

export type AvailabilityType = "examination" | "correction";

const getExpertAvailabilityUrl = (examSessionId: string, availabilityType: AvailabilityType) =>
  `expertAvailability/${examSessionId}/${availabilityType}`;

const expertAvailabilityApi = api.enhanceEndpoints({ addTagTypes: ["ExpertAvailability"] }).injectEndpoints({
  endpoints: (builder) => ({
    getExpertAvailability: builder.query<
      ExpertAvailabilityViewModel,
      { examSessionId: string; availabilityType: AvailabilityType }
    >({
      query: ({ examSessionId, availabilityType }) => getExpertAvailabilityUrl(examSessionId, availabilityType),
      transformResponse: (response: ApiResponse<ExpertAvailabilityViewModel>) => response.data,
      providesTags: (_result, _error, arg) => [
        { type: "ExpertAvailability", id: arg.examSessionId + arg.availabilityType },
      ],
    }),
    updateAvailability: builder.mutation<
      ApiResponse<void>,
      { examSessionId: string; availabilityType: AvailabilityType; expertAvailability: ExpertAvailabilityRequestModel }
    >({
      query: ({ availabilityType, expertAvailability }) => ({
        url: `expertAvailability/${availabilityType}`,
        body: expertAvailability,
        method: "PUT",
      }),
      invalidatesTags: (_result, _error, arg) => [
        { type: "ExpertAvailability", id: arg.examSessionId + arg.availabilityType },
      ],
    }),
  }),
});

export const { endpoints, useGetExpertAvailabilityQuery, useUpdateAvailabilityMutation } = expertAvailabilityApi;
